import React from 'react';
import PageLayout from '../../Components/layout/PageLayout';
import HeroSection from './HeroSection';
import SoftwareServices from './SoftwareServices';
import WhyChooseUs from './WhyChooseUs';
import StatsSection from './StatsSection';
import TestimonialsSection from './TestimonialsSection';
import CTASection from '../../Components/common/CTASection';

const Home = () => {
  return (
    <PageLayout>
      <HeroSection />
      <SoftwareServices />
      <WhyChooseUs />
      <StatsSection />
      <TestimonialsSection />
      <CTASection
        title="Ready to Transform Your Business?"
        description="Let's discuss your project and bring your vision to life with cutting-edge technology"
        buttonText="Get Started"
        buttonLink="/contact"
      />
    </PageLayout>
  );
};

export default Home;
